export function getPathName(params) {
  return params === "p" ? "" : params.replace(/-/g, " ");
}

export function getContextPath(name) {
  if (name) {
    const splitedName = name.split("/");
    if (splitedName.length > 0) {
      name = splitedName[0].trim();
    }
    return name.replace(/\s/g, "-").toLowerCase();
  }
}

export function getUrlPath(name) {
  if (name) {
    return name.replace(/\s/g, "-").toLowerCase();
  }
  return "";
}

export function getTemplateId(name) {
  if (name) {
    const templateId = name.split("-");
    return templateId[0];
  }
}

export function getEncodeTemplateId(id) {
  if (id) {
    const encodedId =
      typeof window === "undefined"
        ? Buffer.from(id).toString("base64")
        : window.btoa(id);
    return encodedId;
  }
}

export function getDecodeTemplateId(id) {
  if (id) {
    const decodedId =
      typeof window === "undefined"
        ? Buffer.from(id, "base64").toString()
        : window.atob(id);
    return decodedId;
  }
}

export function createSitemap(urlList) {
  return `<?xml version="1.0" encoding="UTF-8"?>
          <urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
              ${urlList
                .map((url) => {
                  return `
                      <url>
                          <loc>${url}</loc>
                          <lastmod>${new Date().toISOString()}</lastmod>
                          <changefreq>monthly</changefreq>
                          <priority>1.0</priority>
                      </url>
                  `;
                })
                .join(" ")}
          </urlset>
          `;
}

function getBadgeNo(itemPlan, type, subType) {
  try {
    if (!itemPlan) {
      return false;
    }
    // if (
    //   (["BG", "SCR", "TEXT", "PREBUILT", "CHR", "SCENEPRE"].indexOf(type) ===
    //     -1 &&
    //     type !== "SEARCH") ||
    //   (type === "CHR" && subType !== "CHR") ||
    //   (["BG", "SCR", "TEXT", "PREBUILT"].indexOf(subType) === -1 &&
    //     type === "SEARCH")
    // ) {
    //   return null;
    // }

    const largeVal = Math.max(...itemPlan);

    for (let i = 1; i <= largeVal; i++) {
      if (itemPlan.indexOf(i) !== -1) {
        return i;
      }
    }

    return null;
  } catch (err) {
    console.error("Error in checkUpgrade ", err.stack);
  }
}

export function getIsPremiumTemplate(itemPlan, type, subtype) {
  try {
    const badgeNo = getBadgeNo(
      itemPlan && itemPlan.toJS ? itemPlan.toJS() : itemPlan,
      type,
      subtype
    );
    const userPlanObj = {
      business: 3,
      pro: 3,
      enterprise: 4,
      free: 1,
      growth: 2,
      personal: 2,
      starter: 2,
      startup: 2,
    };
    const userPlan = userPlanObj["free"];
    return badgeNo && badgeNo > userPlan && userPlan === 1;
  } catch (err) {
    console.error("Error in assetBatch ", err.stack);
    return null;
  }
}
